import { render, staticRenderFns } from "./LKRoadmapsExpertsView.vue?vue&type=template&id=2792f969&"
import script from "./LKRoadmapsExpertsView.vue?vue&type=script&lang=js&"
export * from "./LKRoadmapsExpertsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports